<template>
  <div class="card__wrapper">
    <div class="card">
      <h1 class="card__title">{{ $t('messages.profile') }}</h1>
      <div class="card__description">
        <b-form @submit.prevent="save">
          <b-form-group id="firstnameGroup"
                        v-bind:label="(!form.store ? $t('messages.firstname') : $t('messages.company_name')) +':'"
                        label-for="firstname"
                        :invalid-feedback="!form.store ? $t('errors.firstname') : $t('errors.company_name')">
            <b-form-input id="firstname" name="firstname" type="text"
                          v-model.trim="form.firstname"
                          @input="$v.form.firstname.$touch"
                          :state="$v.form.firstname.$dirty ? !$v.form.firstname.$error : null"></b-form-input>
          </b-form-group>
          <b-form-group id="lastnameGroup"
                        v-if="!form.store"
                        v-bind:label="$t('messages.lastname')+':'"
                        label-for="lastname"
                        :invalid-feedback="$t('errors.lastname')">
            <b-form-input id="lastname" name="lastname" type="text"
                          v-model.trim="form.lastname"
                          @input="$v.form.lastname.$touch"
                          :state="$v.form.lastname.$dirty ? !$v.form.lastname.$error : null"></b-form-input>
          </b-form-group>
          <b-form-group id="currentLogoGroup"
                        v-if="form.store && form.store_logo"
                        v-bind:label="$t('messages.logo_current')+':'"
                        label-for="currentLogo">
            <b-img id="currentLogo" name="currentLogo" :src="form.store_logo" class="logo" />
          </b-form-group>
          <b-form-group id="newLogoGroup"
                        v-if="form.store"
                        v-bind:label="$t('messages.logo_new')+':'"
                        label-for="newLogo">
            <span class="small"><strong>{{ $t('messages.logo_info') }}</strong></span>
            <b-form-file id="newLogo" name="newLogo" accept=".png" class="mt-1"
                         v-model="logo"
                         :placeholder="$t('errors.logo_new')"
                         :browse-text="$t('messages.browse')"
                         @change="$v.logo.$touch"
                         :state="$v.logo.$dirty ? !$v.logo.$error : null"></b-form-file>
          </b-form-group>
          <b-form-group id="emailGroup"
                        v-bind:label="$t('messages.email')+':'"
                        label-for="email"
                        :invalid-feedback="emailError">
            <b-form-input id="email" name="email" type="text"
                          v-model.trim="form.email"
                          @input="$v.form.email.$touch"
                          :state="$v.form.email.$dirty ? !$v.form.email.$error : null"></b-form-input>
          </b-form-group>
          <b-form-group id="streetGroup"
                        v-bind:label="$t('messages.street')+':'"
                        label-for="street">
            <b-form-input id="street" name="street" type="text"
                          v-model.trim="form.street"></b-form-input>
          </b-form-group>
          <b-form-group id="house_numberGroup"
                        v-bind:label="$t('messages.housenumber')+':'"
                        label-for="house_number">
            <b-form-input id="house_number" name="house_number" type="text"
                          v-model.trim="form.house_number"></b-form-input>
          </b-form-group>
          <b-form-group id="postal_codeGroup"
                        v-bind:label="$t('messages.postalcode')+':'"
                        label-for="postal_code">
            <b-form-input id="postal_code" name="postal_code" type="text"
                          v-model.trim="form.postal_code"></b-form-input>
          </b-form-group>
          <b-form-group id="locationGroup"
                        v-bind:label="$t('messages.city')+':'"
                        label-for="location"
                        :invalid-feedback="$t('errors.city')">
            <span class="small"><strong>{{ $t('messages.city_explanation') }}</strong></span>
            <location-picker class="mt-1"
                             :city="form.city"
                             :country="form.country"
                             :lat="form.lat"
                             :lng="form.lng"
                             :setCityAndCountry="setCityAndCountry"
                             :isValidState="($v.form.city.$dirty || $v.form.country.$dirty) ? (!$v.form.city.$error && !$v.form.country.$error) : null"></location-picker>
          </b-form-group>
          <b-form-group id="mail_updatesGroup">
            <b-form-checkbox id="mail_updates" name="mail_updates"
                             v-model="form.mail_updates"
                             class="checkboxLineHeight">{{ $t('messages.mail_me_updates') }}</b-form-checkbox>
          </b-form-group>
          <div class="d-inline-flex">
            <div class="flex-grow-1">
              <notification-button :message="$t('messages.save')" :notification="notifications.user" field="user"
                                   :disabled="$v.$invalid"></notification-button>
            </div>
            <div class="flex-grow-1 ml-3 mt-2">
              <b-link v-bind:to="requestpassword">{{ $t('messages.resetpassword') }}</b-link>
            </div>
          </div>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import LocationPicker from '../components/LocationPicker'
import { validationMixin } from 'vuelidate'
import { required, requiredIf, email } from 'vuelidate/lib/validators'
import NotificationButton from '../components/NotificationButton'

import { notificationMixin } from '../mixin/notification'
import { fileSize, fileExtension } from '../lib/validators'

import { userService } from '../services/user.service'

export default {
  name: 'profile',
  metaInfo: function () {
    return {
      title: this.$i18n.t('messages.profile') + ' - CrowdFinder',
      meta: [
        {
          'property': 'og:title',
          'content': this.$i18n.t('messages.profile'),
          'vmid': 'og:title'
        }
      ]
    }
  },
  components: { LocationPicker, NotificationButton },
  data: function () {
    return {
      form: {},
      logo: null,
      oldEmail: '',
      notifications: {
        user: null
      }
    }
  },
  mixins: [ validationMixin, notificationMixin ],
  computed: {
    emailError: function () {
      if (!this.$v.form.email.isUnique) {
        return this.$i18n.t('errors.email_exists')
      }
      return this.$i18n.t('errors.email')
    },
    requestpassword: function () {
      return 'requestpassword?email=' + encodeURIComponent(this.form.email)
    }
  },
  validations: {
    form: {
      firstname: {
        required
      },
      lastname: {
        required: requiredIf(function (value) {
          return !this.form.store
        })
      },
      email: {
        required,
        email,
        isUnique (value) {
          let store = this.$store
          if (value === '') {
            return true
          }

          return new Promise((resolve, reject) => {
            userService.exists(value)
              .then((response) => {
                resolve(response)
              }, (error) => {
                store.commit('error', 'errors.email_exists_problem')
                reject(error)
              })
          })
        }
      },
      city: {
        required
      },
      country: {
        required
      },
      lat: {
        required
      },
      lng: {
        required
      }
    },
    logo: {
      fileSize: fileSize(100),
      fileExtension: fileExtension('png')
    }
  },
  methods: {
    save () {
      if (!this.$v.$invalid) {
        let account = this.$v.form.$model
        let store = this.$store
        let router = this.$router

        account.language = this.$i18n.locale

        let formData = new FormData()
        formData.append('logo', this.logo)
        formData.append('account', JSON.stringify(account))

        userService.update(formData)
          .then(() => {
            if (this.oldEmail === account.email) {
              if (this.logo) {
                this.form.store_logo = Vue.prototype.$hostname.concat('/image/user/').concat(store.state.userId).concat('/').concat(this.logo.name)
                this.logo = null
              }
              store.commit('success', 'success.user')
              this.sendNotification('user', 'success')
            } else {
              userService.logout()
              router.push('/login')
              setTimeout(() => store.commit('success', 'success.user_login_again'))
            }
          }, () => {
            store.commit('error', 'errors.user')
            this.sendNotification('user', 'error')
          })
      }
    },
    setCityAndCountry (city, country, lat, lng) {
      this.$set(this.form, 'city', city)
      this.$set(this.form, 'country', country)
      this.$set(this.form, 'lat', lat)
      this.$set(this.form, 'lng', lng)
      this.$v.form.city.$touch()
      this.$v.form.country.$touch()
      this.$v.form.lat.$touch()
      this.$v.form.lng.$touch()
    }
  },
  created: function () {
    let store = this.$store
    userService.get()
      .then((response) => {
        this.form = response
        this.oldEmail = response.email
        this.$v.form.$touch()
      }, () => {
        store.commit('error', 'errors.user_fetch')
      })

    this.$root.$on('resetNotification', (notification) => {
      this.resetNotification(notification)
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .logo {
    max-width: 150px;
    max-height: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Profile.vue